export default __webpack_public_path__ + "static/media/undraw_date_picker_gorr.a41ad151.svg";